import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { NETWORK_CITIES } from "@/components/site/PublicPresentation";
import { track } from "@/lib/analytics";
import SiteLayout from "@/components/site/SiteLayout";
import Seo, { breadcrumbLd, ogUrl } from "@/components/site/Seo";
import LeadForm from "@/components/site/LeadForm";
import { API } from "@/lib/api";

export default function Contact() {
  const [params] = useSearchParams();
  const verification = params.get("intent") === "verification";
  const [num, setNum] = useState("+919872581418");
  useEffect(() => {
    fetch(`${API}/settings`).then((r) => r.json()).then((d) => d.whatsapp_number && setNum(d.whatsapp_number)).catch(() => {});
  }, []);
  const clean = (num || "").replace(/[^0-9]/g, "");
  return (
    <SiteLayout>
      <Seo
        title="Contact The Sourcing Atlas — Free Sourcing Consultation"
        description="Contact The Sourcing Atlas for a free sourcing consultation. Send your requirement with a drawing or spec sheet, or message us directly on WhatsApp."
        path="/contact"
        ogImage={ogUrl("Tell us what you need sourced", "Get in Touch")}
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]}
      />
      <div className="crumb"><Link to="/">Home</Link> › Contact</div>
      <div className="pband">
        <div className="pband-in">
          <span className="tierpill tn">GET IN TOUCH</span>
          <h1 data-testid="contact-title">{verification ? "Know your supplier. Before you commit." : "Your next sourcing advantage starts here."}</h1>
          <p className="lede">A free 15-minute consultation — we'll tell you honestly which country, which route, and what it should cost.</p>
          <div className="h-ctas">
            <a className="btn btn-red" href={`https://wa.me/${clean}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" onClick={() => track("whatsapp_click", { placement: "contact" })}><MessageCircle size={16} />Message on WhatsApp</a>
          </div>
        </div>
      </div>
      <section>
        <div className="wrap">
          <div className="reqband">
            <div className="reqcopy">
              <div className="k2" style={{ textAlign: "left", color: "#E8C67A" }}>SEND YOUR REQUIREMENT</div>
              <h2>We respond within one business day</h2>
              <p>Attach a drawing, photo or spec sheet. Our team replies with feasibility, a country recommendation and an indicative cost band.</p>
              <p style={{ color: "#CFE0F4", marginTop: 16 }}>{NETWORK_CITIES}</p>
            </div>
            <div className="reqcard"><LeadForm key={verification ? "verification" : "contact"} source="enquiry" defaultDescription={verification ? "Supplier verification request: " : ""} withFile /></div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
